module.exports = __webpack_public_path__ + "img/3.a7eed422.jpg";